import React from 'react';
import scaleSize from '../../utils/scale-size';

export default ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(20)}
    height={scaleSize(25)}
    viewBox="0 0 20 25"
    className={className}
  >
    <path
      fill="#909999"
      fillRule="evenodd"
      d="M18.17 1.136L.585 11.978a1.2 1.2 0 0 0 0 2.043L18.17 24.864A1.2 1.2 0 0 0 20 23.842V2.158a1.2 1.2 0 0 0-1.83-1.022z"
    />
  </svg>
);
